export const preloadModules = (modules) => {
  if (modules?.length > 0) {
    modules.forEach((module) => module.preload());
  }
};
